import React from 'react'

class ErrorBoundary extends React.Component {
    state = { 
        hasError: false ,
        error: null,
        info: null
    };

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        alert("getDerivedStateFromError")
        return { hasError: true };
      }
  
    componentDidCatch(error, info) {
      alert("componentDidCatch")
      this.setState({hasError: true, error, info: info.componentStack})
    }
    render() {
      if (this.state.hasError) {
        return (
            <div className="card">

                <div className="card-body">
                    <h4 className="font-weight-bold mt-4">
                        <span>Ocorreu um erro</span>
                        <hr className="my-4" />
                    </h4>
                </div>

                <p>
                    {this.state.info}
                </p>

            </div>
        )
      }
  
      return this.props.children; 
    }
}

export default ErrorBoundary